import React from "react";
import { DamageSeverityMap } from "../../utils/enums/vehicle";

const DamageChip = ({ damage }) => {
  const damageType = DamageSeverityMap[damage?.severity];

  if (!damageType) {
    return null;
  }

  const damageTypeLowerCase = damageType.toLowerCase();
  const damageLetter = damageTypeLowerCase.charAt(0);

  return (
    <span className="damage-chip-wrapper">
      <span className={`damage-chip ${damageTypeLowerCase}`}>
        {damageLetter}
      </span>

      {damage.inTransit === true && (
        <span className="damage-chip__new-badge">NEW</span>
      )}
    </span>
  );
};

export default DamageChip;
